import { render, staticRenderFns } from "./AcceptanceOfTerms.vue?vue&type=template&id=0a022b2c&scoped=true"
import script from "./AcceptanceOfTerms.vue?vue&type=script&lang=ts"
export * from "./AcceptanceOfTerms.vue?vue&type=script&lang=ts"
import style0 from "./AcceptanceOfTerms.vue?vue&type=style&index=0&id=0a022b2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a022b2c",
  null
  
)

export default component.exports